import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Crumb } from "src/components/Breadcrumb";
import Container from "src/components/layout/Container";
import LayoutFooter from "src/components/layout/LayoutFooter";
import LayoutHead from "src/components/layout/LayoutStudent/LayoutHead";
import LayoutSidebar from "src/components/layout/LayoutStudent/LayoutSidebar";
import NavItemSignout from "src/components/layout/LayoutStudent/NavItem/NavItemSignout";
import NavItems from "src/components/layout/LayoutStudent/NavItems";
import Loader from "src/components/Loader";
import useAuth from "src/hooks/selectors/useAuth";
import useElementSize from "src/hooks/useElementSize";
import useWindowSize from "src/hooks/useWindowSize";

interface LayoutStudentProps {
	children?: any;
	title?: string;
	sidebar?: any;
	loading?: boolean;
	breadcrumb?: Crumb[];
	variant?: "no-container" | "default" | "small" | "large";
	className?: string;
	backUrl?: string;
}

const LayoutStudent = ({
	children,
	title,
	sidebar,
	loading,
	breadcrumb,
	variant,
	className,
	backUrl,
}: LayoutStudentProps) => {
	const auth = useAuth();
	const { isPhone, isTablet } = useWindowSize();
	const { ref: childrenRef, size: childrenSize } = useElementSize();
	const backdropWidth = childrenSize.x - 32;
	const location = useLocation();

	useEffect(() => {
		if (!location?.hash) {
			window.scrollTo(0, 0);
		} else {
			const element = document.getElementById(
				location.hash.replace("#", "")
			);
			if (element) {
				element.scrollIntoView({
					behavior: "smooth",
				});
			}
		}
	}, [location]);

	return (
		<div
			className={`flex flex-col flex-1 ${
				variant !== "no-container" && "pb-16"
			} md:pb-0 transition-all ${className}`}
		>
			{!isPhone && !isTablet && (
				<div
					style={backdropWidth ? { width: backdropWidth } : undefined}
					className="fixed z-10 dark:bg-dark-accent bg-white left-0 top-0 bottom-0"
				/>
			)}
			<LayoutHead {...{ title, breadcrumb }} />
			<Container
				{...{ variant }}
				className="z-10 relative flex flex-col flex-1"
			>
				<div className="flex-1 flex flex-col md:grid grid-cols-9 lg:grid-cols-12 gap-8">
					{!isPhone && !isTablet && (
						<LayoutSidebar>
							<div className="flex flex-col flex-1">
								<div className="flex-1">
									<NavItems />
								</div>
								<NavItemSignout
									className={`gtm-${auth.type}-dashboard-sidebar--link-logout`}
								></NavItemSignout>
							</div>
						</LayoutSidebar>
					)}

					<div
						className={`${
							sidebar ? "col-span-6" : "col-span-9"
						} flex flex-1 flex-col gap-8 ${
							loading && "justify-center items-center"
						}`}
						ref={childrenRef}
					>
						{loading ? (
							<div className="flex-1 flex flex-col justify-center items-center">
								<Loader />
							</div>
						) : (
							children
						)}
					</div>
					{sidebar && <LayoutSidebar>{sidebar}</LayoutSidebar>}
				</div>
				<LayoutFooter />
			</Container>
		</div>
	);
};

LayoutStudent.defaultProps = {
	variant: "xlarge",
};

export default LayoutStudent;
